namespace Matrix.Administration {
    export class UserColumns {
        static columnsKey = 'Administration.User';
    }
}
